import { LocalDate } from 'local-date'
import { Customer } from './Customer'
import { CustomerMeal } from './CustomerMeal'
import { Meal } from './Meal'
import { PaymentSummary } from './PaymentSummary'
import {MenuWeek} from "./MenuWeek";
import {Event} from './Event'
import {MealDateSummary} from "./MealDateSummary";

export type CustomersResponseDTO = {
    customers: Customer[],
    customersForPayments: Customer[],
    customersWithMealDates : Customer[],
    meals: Meal[]
    preventMinutes : number
}

export type MessageResponseDTO = {
    unsentCustomerids : number[];
}

export type EventResponseDTO = {
    events : Event[];
}

export type PaymentSummaryResponseDTO = {
    paymentSummary : PaymentSummary;
}

export type CustomerResponseDTO = {
    customer: Customer
    customerForParent: Customer
    preventMinutes : number
}

export type CustomerMealResponseDTO = {
    customerMealForMealPattern: CustomerMeal
    customerMealForCustomerPattern: CustomerMeal
    customermealEnd : LocalDate
}

export type MealsResponseDTO = {
    meals: Meal[]
    customers : Customer[]
}

export type MealDateResponseDTO = {
    mealDates: MealDateSummary[]
}

export type MealResponseDTO = {
    meal: Meal
}

export enum ResponsePattern {
    CUSTOMER, MEAL
}

export type DinneyAdminResponseDTO = {
    uncreatedCustomers : string[]
}

export type AccountResponseDTO = {
    name : string
    optionalDescription : string
    preventMinutes : number
    response : string
}

export type MenuWeekResponseDTO = {
    publicId : number
    menuWeek : MenuWeek
    menuWeeks : MenuWeek[]
    pairsOfAccountAndMenuId : Pair[]
}

export type Pair = {
    first: string
    second: number
}